<template>
	<div class="content">
		<Header />
		<Banner :src="src" />
		<!-- produvct_banner -->
		<div class="pro_center m">
			<h2>产品中心</h2>

			<div class="m_pro_tab">
				<div class="m_pro_tab_select">
					<p>产品展示</p>
					<span @click="tabShow">{{
						isTabShow ? '点击收起-' : '点击展开+'
					}}</span>
				</div>
				<!-- 下拉列表部分 -->
				<div class="pro_c_m">
					<div class="pro_c_l" v-show="isTabShow">
						<Mytree />
					</div>
					<!-- l -->

					<!-- 选项卡部分 -->

					<!-- r -->
				</div>
			</div>
			<!-- 移动端tab -->
			<!-- pc隐藏 -->
			<div class="pro_c">
				<div class="pro_c_l">
					<h2>
						产品中心
						<p>PRODUCTS CENTER</p>
					</h2>
					<Mytree />
				</div>
				<router-view />
			</div>
		</div>
		<!-- product_center -->
		<Footer />
	</div>
</template>

<script>
import Header from '../../components/Header.vue'
import Banner from '../../components/Banner.vue'
import Footer from '../../components/Footer.vue'
import Mytree from '../../components/MenuList.vue'
import Axios from 'axios'
const Base64 = require('js-base64')
export default {
	components: { Header, Banner, Footer, Mytree },
	data() {
		return {
			src: '',
			activeName: 'first',
			tabName: '',
			actChild: false,
			isTabShow: false,
			content: [],
			contentone: [],
			contenttwo: [],
			contentthree: [],
			contentfour: [],
			contentfive: [],
			contentsix: [],
			treeList: [],
		}
	},
	created() {
		this.tabName = this.$route.params.active + ''
		this.tabName == 'undefined' ? (this.tabName = '1') : this.tabName
			Axios({
			url: 'http://www.bnc.com.cn/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
			}).then((res) => {
			for (var i = 0; i < res.data.data.rows.length; i++) {
				if (
					res.data.data.rows[i].sc_key.slice(0, 21) == 'PRODUCT_CENTER_BANNER'
				) {
					this.src = res.data.data.rows[i].sc_value
				}
			}
		})
	},
	methods: {
		handleSelect(key, keypath) {
			this.tabName = key
			this.isTabShow = false
		},
		handleClick(tab, event) {
			// console.log(tab.label)
			// if (tab.label === '物联网应用软件平台') {
			// 	this.actChild = true
			// } else {
			// 	this.actChild = false
			// }
		},
		handleCommand(command) {
			this.$message('click on item ' + command)
		},
		goDetail() {
			this.tabName = '物联网'
		},
		P_detail() {
			//console.log(1)
		},
		tabShow() {
			this.isTabShow = !this.isTabShow
		},
	},
}
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	@import './index.scss';
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	@import './m-index.scss';
}
</style>